module.exports = __webpack_public_path__ + "img/portraits_10_V.a777a494.jpg";